export const LANGUAGE_AUTO_DETECT = "autodetect";

/*
 * Identity colors for diarized speakers, assigned by first appearance and cycled.
 */
export const SPEAKER_COLORS = [
  "#4A54C8", // indigo
  "#9A3D86", // plum
  "#8F5510", // ochre
  "#3F7A34", // moss
  "#B5432F", // brick
  "#2F6E9E", // steel
  "#7A3FB5", // violet
  "#6B5E57", // taupe
] as const;

export const speakerColor = (index: number): string =>
  SPEAKER_COLORS[Math.max(0, index) % SPEAKER_COLORS.length];

// This is the same as `whisperx.utils.LANGUAGES`
export const WHISPER_LANGUAGE_NAMES: Record<string, string> = {
  af: "afrikaans",
  am: "amharic",
  ar: "arabic",
  as: "assamese",
  az: "azerbaijani",
  ba: "bashkir",
  be: "belarusian",
  bg: "bulgarian",
  bn: "bengali",
  bo: "tibetan",
  br: "breton",
  bs: "bosnian",
  ca: "catalan",
  cs: "czech",
  cy: "welsh",
  da: "danish",
  de: "german",
  el: "greek",
  en: "english",
  es: "spanish",
  et: "estonian",
  eu: "basque",
  fa: "persian",
  fi: "finnish",
  fo: "faroese",
  fr: "french",
  gl: "galician",
  gu: "gujarati",
  ha: "hausa",
  haw: "hawaiian",
  he: "hebrew",
  hi: "hindi",
  hr: "croatian",
  ht: "haitian creole",
  hu: "hungarian",
  hy: "armenian",
  id: "indonesian",
  is: "icelandic",
  it: "italian",
  ja: "japanese",
  jw: "javanese",
  ka: "georgian",
  kk: "kazakh",
  km: "khmer",
  kn: "kannada",
  ko: "korean",
  la: "latin",
  lb: "luxembourgish",
  ln: "lingala",
  lo: "lao",
  lt: "lithuanian",
  lv: "latvian",
  mg: "malagasy",
  mi: "maori",
  mk: "macedonian",
  ml: "malayalam",
  mn: "mongolian",
  mr: "marathi",
  ms: "malay",
  mt: "maltese",
  my: "myanmar",
  ne: "nepali",
  nl: "dutch",
  nn: "nynorsk",
  no: "norwegian",
  oc: "occitan",
  pa: "punjabi",
  pl: "polish",
  ps: "pashto",
  pt: "portuguese",
  ro: "romanian",
  ru: "russian",
  sa: "sanskrit",
  sd: "sindhi",
  si: "sinhala",
  sk: "slovak",
  sl: "slovenian",
  sn: "shona",
  so: "somali",
  sq: "albanian",
  sr: "serbian",
  su: "sundanese",
  sv: "swedish",
  sw: "swahili",
  ta: "tamil",
  te: "telugu",
  tg: "tajik",
  th: "thai",
  tk: "turkmen",
  tl: "tagalog",
  tr: "turkish",
  tt: "tatar",
  uk: "ukrainian",
  ur: "urdu",
  uz: "uzbek",
  vi: "vietnamese",
  yi: "yiddish",
  yo: "yoruba",
  yue: "cantonese",
  zh: "chinese",
};

export const LANGUAGE_STRING_TO_CODE: Record<string, string> = Object.entries(
  WHISPER_LANGUAGE_NAMES,
).reduce<Record<string, string>>((map, [code, name]) => {
  map[code] = code;
  map[name] = code;
  return map;
}, {});
